import React from "react";

import CustomFormatNumber from "components/CustomFormatNumber";
import { PROJECT_STATUS } from "constants/status";
import { getProjectInvestmentStatusLookUp } from "utils/statusLookUp";
import { formatNoDecimalNumber } from "utils";
import { useFormattedMessage } from "hooks";
import IntlFormattedMessage from "components/IntlFormattedMessage";
import ToolTip from "components/ToolTip";

const messages = {
    financingCompletedTitle: "financing_phase_completed",
    financingCompletedContent: "pib_financing_completed_content",
    progressText: "order_status_progress",
    currentRatingText: "pib_current_rating_text",
    initialInvestmentText: "initial_investment_amount",
    lastInvestmentText: "pib_last_investment_text",
    currentStatusText: "pib_current_status_text",
    financingStatusCalculationHeading: "financing_status_calculation_heading",
    financingStatusCalculationContent: "financing_status_calculation_content",
};

const statuses = {
    [PROJECT_STATUS.ADVERTISING]: "bg-primary-light advertising",
    [PROJECT_STATUS.FUNDING_ACTIVE]: "bg-secondary-dark funding-active",
    [PROJECT_STATUS.VIP_FUNDING]: "bg-secondary-dark funding-active",
    [PROJECT_STATUS.FINANCING_COMPLETED]: "bg-primary-light funding-closed",
    [PROJECT_STATUS.FUNDING_CLOSED]: "bg-primary-light funding-closed",
    [PROJECT_STATUS.MARKETPLACE]: "bg-secondary-dark marketplace",
    [PROJECT_STATUS.SUCCESSFULLY_PAID_BACK]: "bg-light-green successfully-paid-back",
};

function statusClass(status) {
    return statuses[status] || "bg-primary-light";
}

const PropertyInfoBox = ({ className, status, fundingPercentage, fundingNews, isLoggedIn }) => {
    const { formatMessage } = useFormattedMessage();
    const investmentStatustext = getProjectInvestmentStatusLookUp(status)?.text;
    const info = (
        <>
            <span
                className="question ml-2 black-color"
                data-tooltip-id="progress-info"
                data-tooltip-html={`<div>
                <label>${formatMessage(messages.financingStatusCalculationHeading)}</label>
                <p class="text-12 mt-2 mb-0">${formatMessage(messages.financingStatusCalculationContent)}</p>
                </div>`}
            >
                i
            </span>
            <ToolTip id="progress-info" />
        </>
    );
    return (
        <section className={`item-block shadow border-radius funding ${statusClass(status)} ${className}`}>
            {status === PROJECT_STATUS.FINANCING_COMPLETED || status === PROJECT_STATUS.FUNDING_CLOSED ? (
                <>
                    <h3 className="my-0">{formatMessage(messages.financingCompletedTitle)}</h3>
                    <span className="mt-4 mb-3 text-16 d-block">{formatMessage(messages.financingCompletedContent)}</span>
                    <div className="position-relative">
                        <div className="flex justify-between align-center">
                            <span className="text-12 fw-600 d-block">{formatMessage(messages.progressText)}</span>
                            <span className="text-18 fw-600 d-flex align-center">100% {info}</span>
                        </div>
                        <div className="flex row justify-center align-center progress">
                            <div className="progress_bar_wrap">
                                <div className="progress_bar_inner" style={{ width: "100%" }} />
                            </div>
                        </div>
                    </div>
                </>
            ) : status === PROJECT_STATUS.MARKETPLACE && isLoggedIn ? (
                <>
                    <div className="flex justify-between align-center border-bottom">
                        <span className="text-14 fw-600 d-block mt-0">
                            <IntlFormattedMessage id={messages.currentRatingText} />
                        </span>
                        <span className="text-display mt-0">
                            {formatNoDecimalNumber(856)} <span className="h3">€</span>
                        </span>
                    </div>
                    <div className="flex justify-between align-center">
                        <span className="text-14 fw-600 d-block">{formatMessage(messages.initialInvestmentText)}</span>
                        <span className="text-18 fw-600">
                            <CustomFormatNumber value={800} />
                        </span>
                    </div>
                    <div className="flex justify-between align-center">
                        <span className="text-14 fw-600 my-0">{formatMessage(messages.lastInvestmentText)}</span>
                        <span className="text-18 fw-600">13.09.2019</span>
                    </div>
                </>
            ) : (
                (status === PROJECT_STATUS.ADVERTISING ||
                    status === PROJECT_STATUS.FUNDING_ACTIVE ||
                    status === PROJECT_STATUS.VIP_FUNDING) && (
                    <>
                        <h3 className="my-0">{investmentStatustext}</h3>
                        {(status === PROJECT_STATUS.FUNDING_ACTIVE || status === PROJECT_STATUS.VIP_FUNDING) && (
                            <>
                                <div className="flex justify-between align-center">
                                    <span className="text-12 fw-600 d-block">{formatMessage(messages.progressText)}</span>
                                    <span className="text-18 fw-600 d-flex align-center">
                                        {fundingPercentage}%{info}
                                    </span>
                                </div>
                                <div className="flex row justify-center align-center progress">
                                    <div className="progress_bar_wrap">
                                        <div className="progress_bar_inner" style={{ width: `${fundingPercentage}%` }} />
                                    </div>
                                </div>
                            </>
                        )}
                        <span className="text-12 fw-600 d-block">{formatMessage(messages.currentStatusText)}</span>
                        <h3 className="my-0">{fundingNews}</h3>
                    </>
                )
            )}
        </section>
    );
};

export default PropertyInfoBox;
